module.exports = __webpack_public_path__ + "static/media/arrow.44f28ff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Home/images/arrow.png
// module id = 83
// module chunks = 0